import { render } from "./DealerForm.vue?vue&type=template&id=129f5c44&scoped=true"
import script from "./DealerForm.vue?vue&type=script&lang=js"
export * from "./DealerForm.vue?vue&type=script&lang=js"

import "./DealerForm.vue?vue&type=style&index=0&id=129f5c44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129f5c44"]])

export default __exports__